import React, {Component} from 'react';

import PropTypes from 'prop-types';
import Button from 'react-bootstrap/lib/Button';

import deleteImage from '@/assets/icons/backspace.svg';

export default class FmlxNumPadKeys extends Component {
  //   getSideKeyRows() {
  //     const {isFloating} = this.props;
  //     if (isFloating) {
  //       return [operationSymbol.delete, operationSymbol.clear, operationSymbol.ok];
  //     }
  //     return [operationSymbol.delete, operationSymbol.clear];
  //   }

  // eslint-disable-next-line class-methods-use-this
  getSideKeyCellClassName(name) {
    let result;
    if (name === operationSymbol.ok) {
      result = 'numpadKey-cell ok-key';
    } else if (name === operationSymbol.clear) {
      result = 'numpadKey-cell clear-key';
    } else {
      result = 'numpadKey-cell del-key';
    }
    return result;
  }

  // eslint-disable-next-line class-methods-use-this
  getSideKeyCellSize(totalButton, keyIndex) {
    switch (totalButton) {
      case 4:
        return '1';
      case 3:
        if (keyIndex === totalButton - 1) {
          return '2';
        }
        return '1';

      case 2:
        return '2';
      case 1:
        return '4';
      default:
        return '';
    }
  }

  // eslint-disable-next-line class-methods-use-this
  switchOpSymToOpKey(opContainer) {
    switch (opContainer) {
      case operationSymbol.clear:
        return operationKey.clear;
      case operationSymbol.delete:
        return operationKey.delete;
      case operationSymbol.dot:
        return operationKey.dot;
      case operationSymbol.negate:
        return operationKey.negate;
      case operationSymbol.ok:
        return operationKey.ok;
      default:
        return opContainer;
    }
  }

  //   getMainKeyRows() {
  //     const {numPadButtonType} = this.props;

  //     if (numPadButtonType === 'calculator') {
  //       return [
  //         ['7', '8', '9'],
  //         ['4', '5', '6'],
  //         ['1', '2', '3'],
  //         [operationSymbol.dot, '0', operationSymbol.negate],
  //       ];
  //     }
  //     if (numPadButtonType === 'number') {
  //       return [['7', '8', '9'], ['4', '5', '6'], ['1', '2', '3'], ['0']];
  //     }
  //     return [
  //       ['1', '2', '3'],
  //       ['4', '5', '6'],
  //       ['7', '8', '9'],
  //       [operationSymbol.dot, '0', operationSymbol.negate],
  //     ];
  //   }

  renderMainKeys() {
    const {onKeyClicked, isAllowDecimal, isAllowNegative, mainKeys} = this.props;
    const mainKeyRows = mainKeys; // this.getMainKeyRows();

    return (
      <div className="numpadKey-mainKey">
        {mainKeyRows.map((row, key) => (
          <div
            // eslint-disable-next-line react/no-array-index-key
            key={key}
            className="numpadKey-row"
          >
            {row.map((cur, key) => {
              let disabled = false;
              if (cur === '.') {
                disabled = !isAllowDecimal;
              } else if (cur === '+/-') {
                disabled = !isAllowNegative;
              }
              const opKey = this.switchOpSymToOpKey(cur);
              return (
                <div
                  // eslint-disable-next-line react/no-array-index-key
                  key={key}
                  className="numpadKey-cell"
                >
                  <Button
                    disabled={disabled}
                    onClick={() => onKeyClicked(opKey)}
                  >
                    {cur}
                  </Button>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }

  renderSideKeys() {
    const {onKeyClicked, sideKeys} = this.props;
    const sideKeyRows = sideKeys; // this.getSideKeyRows();

    if (!sideKeyRows) {
      return null;
    }
    return (
      <div className="numpadKey-sideKey">
        {sideKeyRows.map((cur, key) => {
          const opKey = this.switchOpSymToOpKey(cur);
          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={key}
              className="numpadKey-row"
            >
              <div className={this.getSideKeyCellClassName(cur)}>
                <Button
                  onClick={() => onKeyClicked(opKey)}
                  size={this.getSideKeyCellSize(sideKeyRows.length, key)}
                >
                  {cur}
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    return (
      <div className="numpadKey">
        {this.renderMainKeys()}
        {this.renderSideKeys()}
      </div>
    );
  }
}

const operationSymbol = {
  delete: (
    <img
      src={deleteImage}
      alt={deleteImage}
    />
  ),
  clear: 'C',
  ok: 'OK',
  negate: '+/-',
  dot: '.',
};

FmlxNumPadKeys.operationSymbol = operationSymbol;
const operationKey = {
  delete: 'Del',
  clear: 'Clr',
  ok: 'Ok',
  negate: 'PlusMin',
  dot: 'Dot',
};

FmlxNumPadKeys.operationKey = operationKey;

FmlxNumPadKeys.numPadKeyType = {
  phone: 'phone',
  calculator: 'calculator',
};

FmlxNumPadKeys.defaultProps = {
  //   isFloating: false,
  isAllowDecimal: true,
  isAllowNegative: true,
  onKeyClicked: () => {},
  mainKeys: [],
  sideKeys: [],
};

FmlxNumPadKeys.propTypes = {
  mainKeys: PropTypes.array,
  sideKeys: PropTypes.array,
  //   isFloating: PropTypes.bool,
  isAllowDecimal: PropTypes.bool,
  isAllowNegative: PropTypes.bool,
  onKeyClicked: PropTypes.func,
};
